import React, { useEffect, useState } from "react";
import styles from "./../checkout.module.css";
import AddEditMemberChk from "./AddEditMemberChk";
import { profileAction } from "../../../redux/action";
import { convertToDate, getAgeText, getFullName, getUser, isCardEmtpy } from "../../../constant/utils";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import MemberChangePopup from "../component/MemberChangePopup";
interface IBooking {
  bookingData: any;
  setBookingData: (val: any) => void;
  cardEntry: any[];
  setCardEntry: (val: any) => void;
}
const Member = ({ bookingData, setBookingData, cardEntry, setCardEntry }: IBooking) => {
  const USER: any = getUser();
  const dispatch = useDispatch();
  const ExistCardData: any[] = JSON.parse(localStorage.getItem("CartData") || "[]");
  const [openMemberChange, setOpenMemberChange] = useState<boolean>(false);
  const [removeData, setRemoveData] = useState<any[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const patientData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );

  useEffect(() => {
    if (!patientData?.pid) {
      setOpen(true);
    }
  }, [USER?.Id]);

  const handleOpen = (data: any) => {
    setEditData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setEditData({});
    setOpen(false);
  };
  const handleSubmit = (data: any) => {
    let newData = {
      ...data,
      dob: convertToDate(data?.dob),
    };
    if (editData?.pid || editData?.id) {
      if (editData?.pid && editData?.family) {
        dispatch(profileAction.updatePatientAction({ ...newData, pid: editData?.pid }, () => onSuccessAddMember()));
      } else {
        dispatch(profileAction.updateFamilyMemberAction({ ...newData, id: editData?.id }, () => onSuccessAddMember()));
      }
    } else {
      if (patientData?.pid) {
        dispatch(profileAction.addFamilyMemberAction(newData, () => onSuccessAddMember()));
      } else {
        dispatch(
          profileAction.createPatientAction(newData, () => {
            dispatch(profileAction.addFamilyMemberAction(newData, () => onSuccessAddMember()));
            setOpen(false);
          })
        );
      }
    }
  };
  function onSuccessAddMember() {
    if (bookingData?.selectedMember?.details?.id == editData?.details?.id) {
      setBookingData({
        ...bookingData,
        tab: "member",
        selectedMember: undefined,
        PaymentMode: "",
      });
    }
    setEditData({});
    setOpen(false);
  }
  function handleCloseModalRemove() {
    setOpenMemberChange(false);
    setEditData({});
    setRemoveData([]);
  }
  function handleMemberSelect(data: any) {
    if (data?.selectedMember?.gender) {
      data?.selectedMember?.gender?.toUpperCase();
      const newData: any[] = ExistCardData?.filter(
        (ele: any) =>
          ele?.Gender != "both" &&
          ele?.Gender &&
          ele?.Gender?.toUpperCase() !== data?.selectedMember?.gender?.toUpperCase()
      );
      if (newData?.length > 0) {
        setRemoveData(newData);
        setEditData(data);
        setOpenMemberChange(true);
      } else {
        setBookingData({
          ...bookingData,
          ...data,
        });
      }
    } else {
      setBookingData({
        ...bookingData,
        ...data,
      });
    }
  }
  const removeFromCart = (data: any) => {
    let CartData: any[] = [...cardEntry];
    let newArr: any[] = CartData?.filter((ele: any) => !(ele?.Id == data?.Id && ele?.Type == data?.Type));
    let newRemoveArr: any[] = removeData?.filter((ele: any) => !(ele?.Id == data?.Id && ele?.Type == data?.Type));
    setRemoveData(newRemoveArr);
    setCardEntry(newArr);
    localStorage.setItem("CartData", JSON.stringify(newArr));
    if (newRemoveArr?.length == 0) {
      setBookingData({ ...bookingData, ...editData, CardData: newArr });
      setOpenMemberChange(false);
    } else {
      setBookingData({ ...bookingData, CardData: newArr });
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          maxHeight: "280px",
          overflowY: "auto",
        }}
      >
        <div className={styles.memberBoxList}>
          <div className="d-flex justify-content-center align-items-center" style={{ width: "200px" }}>
            <a
              href=""
              style={{ width: "150px", padding: "5px 20px" }}
              className="book--hexagon active"
              onClick={(e: any) => {
                e.preventDefault();
                handleOpen({});
              }}
            >
              <span className="text-capitalize">
                <img className="mr-2" src="assets/img/my-profile/white-plus.png" aria-hidden="true" />
                Add Member
              </span>
            </a>
          </div>
          {patientData?.pid && (
            <div
              className={`${styles.memberBox} ${
                patientData?.details?.id && bookingData?.selectedMember?.details?.id == patientData?.details?.id
                  ? styles.activeBox
                  : ""
              }`}
              onClick={() => {
                if (!isCardEmtpy()) {
                  handleMemberSelect({
                    tab: "address",
                    selectedMember: {
                      pid: patientData?.pid,
                      id: patientData?.details?.id,
                      details: patientData?.details,
                      dob: patientData?.dob,
                      first_name: patientData?.first_name,
                      last_name: patientData?.last_name,
                      mobile_no: patientData?.mobile_no,
                      gender: patientData?.gender,
                      relation: patientData?.relation,
                      salutation: patientData?.salutation,
                    },
                  });
                }
              }}
            >
              <div className={styles.memberDetails}>
                <div className={styles.nameText}>
                  <i className="fa fa-user" aria-hidden="true"></i>
                  {getFullName(patientData?.first_name, patientData?.last_name)},
                </div>
                <div>
                  <i className="fa fa-male" aria-hidden="true"></i>
                  {`${patientData?.gender || ""}, ${getAgeText(patientData?.dob)}`},
                </div>
                <div>
                  <i className="fa fa-handshake-o" aria-hidden="true" style={{ fontSize: "12px" }}></i>
                  {patientData?.relation_txt}
                </div>
                <div>
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  {`+91 ${patientData?.mobile_no}`}
                </div>
              </div>
              <div className={styles.editAddressIcon}>
                <img
                  src={
                    bookingData?.selectedMember?.details?.id == patientData?.details?.id
                      ? "/assets/img/my-profile/yedit.png"
                      : "/assets/img/my-profile/bedit.png"
                  }
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleOpen(patientData);
                  }}
                />
              </div>
              {bookingData?.selectedMember?.details?.id == patientData?.details?.id && (
                <div className={styles.selectedIcon}>
                  <img src="assets/img/my-profile/ptick.png" />
                </div>
              )}
            </div>
          )}
          {patientData?.family &&
            patientData?.family?.length > 0 &&
            patientData?.family?.map((member: any) => (
              <div
                className={`${styles.memberBox} ${
                  member?.details?.id && bookingData?.selectedMember?.details?.id == member?.details?.id
                    ? styles.activeBox
                    : ""
                }`}
                onClick={() => {
                  if (!isCardEmtpy()) {
                    handleMemberSelect({
                      tab: "address",
                      selectedMember: { ...member, dob: convertToDate(member?.dob) },
                    });
                  }
                }}
              >
                <div className={styles.memberDetails}>
                  <div className={styles.nameText}>
                    <i className="fa fa-user" aria-hidden="true"></i>
                    {getFullName(member?.first_name, member?.last_name)},
                  </div>
                  <div>
                    <i className="fa fa-male" aria-hidden="true"></i>
                    {`${member?.gender || ""}, ${getAgeText(member?.dob)}`},
                  </div>
                  <div>
                    <i className="fa fa-handshake-o" aria-hidden="true" style={{ fontSize: "12px" }}></i>
                    {member?.relation_txt}
                  </div>
                  <div>
                    <i className="fa fa-phone" aria-hidden="true"></i>
                    {`+91 ${member?.mobile_no}`}
                  </div>
                </div>
                <div className={styles.editAddressIcon}>
                  <img
                    src={
                      member?.details?.id && bookingData?.selectedMember?.details?.id == member?.details?.id
                        ? "/assets/img/my-profile/yedit.png"
                        : "/assets/img/my-profile/bedit.png"
                    }
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleOpen(member);
                    }}
                  />
                </div>
                {member?.details?.id && bookingData?.selectedMember?.details?.id == member?.details?.id && (
                  <div className={styles.selectedIcon}>
                    <img src="assets/img/my-profile/ptick.png" />
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
      {open && (
        <AddEditMemberChk open={open} editData={editData} handleClose={handleClose} handleSubmit={handleSubmit} />
      )}
      {openMemberChange && (
        <MemberChangePopup
          open={openMemberChange}
          handleClose={handleCloseModalRemove}
          removeData={removeData}
          removeFromCart={removeFromCart}
          editData={removeData}
        />
      )}
    </React.Fragment>
  );
};

export default Member;
